import { FC, PropsWithChildren } from "react";
import useSentryUser from "../../../hooks/sentry/useSentryUser";

interface ISentryUserProviderProps extends PropsWithChildren {

}

const SentryUserProvider: FC<ISentryUserProviderProps> = ({
    children
}) => {
    useSentryUser();
    
    return (
        <>
            {children}
        </>
    )
}

export default SentryUserProvider;